import { defineStore } from 'pinia'

import {
  disconnectQuickBooks,
  getQuickBooksConnectUrl,
  getQuickBooksStatus,
} from '@/domains/integrations/quickbooks/services/quickBooksService'

export const useQuickBooksStore = defineStore('quickbooks', {
  actions: {
    async bootstrap() {
      await this.checkAuthStatus()
    },

    async checkAuthStatus() {
      try {
        const response = await getQuickBooksStatus()
        this.environment = String(response?.environment || '')
          .trim()
          .toLowerCase()
        const authenticated = !!response?.authenticated
        this.setAuthenticated(authenticated)
        if (authenticated) {
          this.clearReconnectRequired()
        } else {
          this.markReconnectRequired({
            authUrl: response?.reauth?.auth_url,
            message: response?.reauth?.message,
          })
        }
      } catch (error) {
        this.environment = ''
        this.setAuthenticated(false)
        console.error('Failed to check QuickBooks auth status', error)
      }
    },

    clearReconnectRequired() {
      this.requiresReconnect = false
      this.reconnectMessage = ''
      this.reconnectAuthUrl = ''
    },

    async connect() {
      const returnTo =
        `${window.location.pathname}${window.location.search}${window.location.hash}` ||
        '/'
      const authUrl = await getQuickBooksConnectUrl(returnTo)
      if (!authUrl) {
        throw new Error('QuickBooks auth URL was not returned.')
      }
      this.reconnectAuthUrl = authUrl
      window.location.assign(authUrl)
    },

    async disconnect() {
      await disconnectQuickBooks()
      await this.checkAuthStatus()
    },

    markReconnectRequired({ authUrl, message } = {}) {
      this.requiresReconnect = true
      this.reconnectMessage = String(
        message || 'QuickBooks session expired. Reconnect required.'
      )
      this.reconnectAuthUrl = String(authUrl || '')
      this.setAuthenticated(false)
    },

    setAuthenticated(value) {
      this.isAuthenticated = !!value
    },
  },

  persist: {
    key: 'quickbooks-auth',
    paths: [
      'isAuthenticated',
      'requiresReconnect',
      'reconnectMessage',
      'reconnectAuthUrl',
    ],
  },

  state: () => ({
    environment: '',
    isAuthenticated: false,
    reconnectAuthUrl: '',
    reconnectMessage: '',
    requiresReconnect: false,
  }),
})
